// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__M3Swx","filesListContainer":"PosDisputesFiles_filesListContainer__1WVyU","filesButton":"PosDisputesFiles_filesButton__ghPUD"};